/**
 * @file useSafeTranslation.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el hook useSafeTranslation
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-14
 * @author DLTCode
 * @author Daniel Sentamans
 * @copyright © DLTCode
 * @license Private
 * */

import { useTranslations } from "next-intl";
import type { Messages } from "next-intl";
type TranslationNamespace = keyof Messages;
export function useSafeTranslation(namespace: TranslationNamespace) {
  const t = useTranslations(namespace);
  const translate = t as (_key: string, ..._args: unknown[]) => string;
  const safeT = (key: string): string | null => {
    try {
      const result = translate(key);
      // En desarrollo, next-intl/use-intl puede devolver:
      // - "key"
      // - "namespace.key"
      // cuando no encuentra la traducción.
      const missingKeyValues = [key, `${namespace}.${key}`];
      return missingKeyValues.includes(result) ? null : result;
    } catch {
      return null;
    }
  };
  return safeT;
}